import React from 'react';
import { Card, Field, TextField, SaveButton } from '../AdminUI';
import { useSite } from '../../../context/SiteContext';
import { toast } from 'sonner';
import { Plus, Trash2 } from 'lucide-react';

export default function FooterSection() {
  const { data, update } = useSite();
  const [f, setF] = React.useState(data.footer);
  // Only re-sync from `data` when the footer's shape (column count) changes —
  // otherwise a background poll of `data` would clobber the admin's in-progress
  // edits. Same fix as ProductsSection.
  const remoteColCount = (data.footer?.columns || []).length;
  const localColCount = (f?.columns || []).length;
  React.useEffect(() => {
    if (remoteColCount !== localColCount) setF(data.footer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remoteColCount]);

  const save = () => { update((p) => ({ ...p, footer: f })); toast.success('Saved successfully'); };
  const setCol = (i, k, v) => setF({ ...f, columns: f.columns.map((c, idx) => idx === i ? { ...c, [k]: v } : c) });
  const setItem = (ci, ii, v) => setF({ ...f, columns: f.columns.map((c, idx) => idx === ci ? { ...c, items: c.items.map((it, jdx) => jdx === ii ? v : it) } : c) });
  const removeItem = (ci, ii) => setF({ ...f, columns: f.columns.map((c, idx) => idx === ci ? { ...c, items: c.items.filter((_, jdx) => jdx !== ii) } : c) });
  const addItem = (ci) => setF({ ...f, columns: f.columns.map((c, idx) => idx === ci ? { ...c, items: [...c.items, 'New Link'] } : c) });

  return (
    <Card title="Footer" desc="About section, link columns and copyright." footer={<SaveButton onClick={save} />}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
        <Field label="About Title"><TextField value={f.aboutTitle} onChange={(v) => setF({ ...f, aboutTitle: v })} /></Field>
        <Field label="Copyright"><TextField value={f.copyright} onChange={(v) => setF({ ...f, copyright: v })} /></Field>
        <div className="md:col-span-2">
          <Field label="About Text"><TextField value={f.aboutText} onChange={(v) => setF({ ...f, aboutText: v })} /></Field>
        </div>
      </div>
      <div className="space-y-3">
        {f.columns.map((c, i) => (
          <div key={i} className="rounded-lg border border-zinc-800 bg-zinc-900/40 p-3">
            <Field label="Column Title"><TextField value={c.title} onChange={(v) => setCol(i, 'title', v)} /></Field>
            <div className="mt-2 space-y-1.5">
              {c.items.map((it, j) => (
                <div key={j} className="flex items-center gap-2">
                  <TextField value={it} onChange={(v) => setItem(i, j, v)} />
                  <button onClick={() => removeItem(i, j)} className="h-9 px-2 rounded-md bg-red-600/15 text-red-300 border border-red-900/40"><Trash2 size={14} /></button>
                </div>
              ))}
              <button onClick={() => addItem(i)} className="text-xs text-[color:var(--gold)] hover:underline flex items-center gap-1"><Plus size={12} /> Add link</button>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
